import baseColumnsForm from 'formiojs/components/columns/Columns.form';
import { ignoreBuilderFields } from '#web-components/utils';
import { defaultConditionalFields, defaultApiFields } from '#web-components/components/Form/constants';

const datagridDescription = [
  '<ol>',
  '<li>The space containing the Columns component is divided into 12 parts.</li>',
  '<li>The width of each column is set in these parts.</li>',
  '<li>Offset is an indentation at the beginning of a column.</li>',
  '</ol>',

  'Example:',

  '<ol>',
  '<li>When the width of the first column is 5, and the width of the second is 7, '
  + ' then the first column takes 5/12 of the container width, and the second takes 7/12 of the container width.</li>',
  '<li>When for the second column offset=1 and width=6, '
  + 'then there is an indentation between the first and the second columns in 1/12 of the container width.</li>',
  '</ol>',

  'It is recommended to set the width and offset in a way that their sum is 12. '
  + 'When the sum exceeds 12, the columns that don\'t fit the width will be transferred to the next row.',
].join('\n');

export default () => {
  return baseColumnsForm([
    ...ignoreBuilderFields(['layout', 'logic']),
    {
      key: 'display',
      components: [
        ...ignoreBuilderFields(
          ['customClass', 'modalEdit', 'autoAdjust', 'hideLabel'],
        ),
        {
          weight: 150,
          type: 'datagrid',
          input: true,
          key: 'columns',
          label: 'Column Properties',
          description: datagridDescription,
          addAnother: 'Add Column',
          tooltip: 'The width, offset, push, and pull settings for each column.',
          reorder: true,
          components: [
            {
              type: 'hidden',
              key: 'components',
              defaultValue: [],
            },
            {
              type: 'select',
              key: 'size',
              defaultValue: 'md',
              ignore: true,
            },
            {
              type: 'number',
              key: 'width',
              defaultValue: 6,
              label: 'Width',
            },
            {
              type: 'number',
              key: 'offset',
              defaultValue: 0,
              label: 'Offset',
            },
            {
              type: 'number',
              key: 'push',
              defaultValue: 0,
              label: 'Push',
              ignore: true,
            },
            {
              type: 'number',
              key: 'pull',
              defaultValue: 0,
              label: 'Pull',
              ignore: true,
            },
          ],
        },
      ],
    },
    {
      key: 'api',
      components: [
        ...ignoreBuilderFields(['tags', 'properties']),
        ...defaultApiFields,
      ],
    },
    {
      key: 'conditional',
      components: defaultConditionalFields,
    },
  ]);
};
